import i18n from "@/plugins/vue-i18n";

export default {
  namespaced: true,

  state: {
    status: {
      activated: {
        text: i18n.t("categories.active"),
        color: "green",
        value: true,
      },
      deactivated: {
        text: i18n.t("categories.inactive"),
        color: "gray",
        value: false,
      },
    },
    filtersForm: null,
  },

  getters: {
    getStatuses(state) {
      return Object.values(state.status);
    },

    getStatus(state) {
      return (isActive) => {
        return isActive ? state.status.activated : state.status.deactivated;
      };
    },

    getCanUseFilterOptions() {
      return [
        { text: i18n.t("categories.filters.canUseYes"), value: true },
        { text: i18n.t("categories.filters.canUseNo"), value: false },
      ];
    },

    getFiltersOptions(state) {
      return state.filtersForm;
    },
  },

  mutations: {
    SET_FILTERS_FORM(state, form) {
      state.filtersForm = form;
    },
  },
};
